
export enum NcodePdfScaleMode {
  IMAGE_SIZE_UP_TO_PAGE,
  PAGE_SIZE_DOWN_TO_IMAGE,
  NO_SCALE,

  IMAGE_SIZE_UP_TO_PAGE_PADDING,
}


export enum ColorConvertMethod {
  BLUEPRINT,
  ANDROID_STYLE,
  IPHONE_STYLE,
}
